mutation UpdateUserLocale($input: UpdateUserLocaleInput!) {
  updateUserLocale(input: $input)
}
